import Map from 'ol/Map';
import React from 'react';
import { fromLonLat } from 'ol/proj';
import View from 'ol/View';
import { defaults as defaultControls, Zoom } from 'ol/control';
import { defaults as defaultInteractions, MouseWheelZoom } from 'ol/interaction';
import { MapAdapter } from './mapAdapter';
import { MapEntity } from '../../types/game-document/entities';

export const MapContext = React.createContext<Map>(
  new Map({
    layers: [
      new MapAdapter({ type: 'googleMaps' } as MapEntity).baseLayer
    ],
    view: new View({
      center: fromLonLat([0, 0]),
      zoom: 7,
      extent: [-20026376.39, -20048966.1, 20026376.39, 20048966.1],
      constrainOnlyCenter: false,
      constrainResolution: false,
      smoothExtentConstraint: true
    }),
      interactions: defaultInteractions({ mouseWheelZoom: false }).extend([
      new MouseWheelZoom({
        maxDelta: 0.5,
        constrainResolution: false
      })
    ]),

    controls: defaultControls({
      zoom: false
    }).extend([
      new Zoom({
        delta: 0.25
      })
    ])
  })
);
